<script lang="ts">
    import { page } from "$app/stores";
    import { reportBug } from "$lib/functions/reportBug.js";
    import { onMount } from "svelte";

    export let data;

    onMount(() => {
        reportBug(data.user?.id, data.user?.email, data.user?.full_name);
    });
</script>

<h1 class="text-center font-semibold text-3xl xs:pt-12">
    {$page.error?.message ??
        "There was an error, please try again. If the problem persists, try signing out and in again."}
</h1>
